import type { ServicePreset } from '@/types/domain';
import { Card } from '@/components/atoms/Card';
import { formatPrice } from '@/utils/price';
import styles from './OrderCard.module.css';

export interface PresetCardProps {
  preset: ServicePreset;
  onClick?: () => void;
}

export function PresetCard({ preset, onClick }: PresetCardProps): JSX.Element {
  return (
    <Card interactive={!!onClick} onClick={onClick}>
      <div className={styles.card}>
        <div className={styles.row}>
          <span className={styles.title}>{preset.title}</span>
          {/* F-170 B3.3: "від {price} €" when `price_is_from` is set
              (B0.4b) — both readouts share `formatPrice`. */}
          <span className={styles.price}>
            {formatPrice(preset.price_eur, preset.price_is_from)}
          </span>
        </div>
        {preset.description ? <div className={styles.meta}>{preset.description}</div> : null}
        {preset.duration_minutes ? (
          <div className={styles.meta}>⏱ {preset.duration_minutes} хв</div>
        ) : null}
      </div>
    </Card>
  );
}
